import { render, staticRenderFns } from "./common-access-filter.vue?vue&type=template&id=5051c986&"
import script from "./common-access-filter.vue?vue&type=script&lang=js&"
export * from "./common-access-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports